import { AxiosError } from 'axios';

import { axiosMeedioClient } from './client';
import { dedupeInFlight } from './inFlightDedupe';
import { MeetingResponse } from './types';

export const getMeetingByRoomId = (roomId: string): Promise<MeetingResponse | null> =>
  dedupeInFlight(`room:${roomId}`, async () => {
    try {
      const { data } = await axiosMeedioClient.get<MeetingResponse>(`/room/id/${roomId}`);
      return data;
    } catch (error) {
      if (error instanceof AxiosError) {
        const status = error.response?.status;
        if (status === 404 || status === 403) return null;
      }
      throw error;
    }
  });
